/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_right': {
    width: 15,
    height: 24,
    viewBox: '0 0 15 24',
    data: '<path pid="0" d="M9.973 11.995l-9.536 8.98c-.26.246-.407.58-.407.927 0 .348.147.682.407.928l.836.786c.261.246.616.384.985.384.37 0 .724-.138.986-.384l11.35-10.69c.26-.248.406-.582.406-.931 0-.35-.146-.684-.406-.932L3.254.383A1.441 1.441 0 002.27 0c-.37 0-.724.138-.986.384l-.835.786c-.262.247-.408.58-.408.929 0 .348.146.682.408.928l9.525 8.97z" _fill="#fff"/>'
  }
})
